import React from "react"

import "./HandrulesBox.css"
import HandrulesEntry from "../HandrulesEntry/HandrulesEntry"
import arrow from "../../../assets/icons/arrow.svg"
import config from "../../../config";
import { useApi } from "../../../hooks/useApi";

const HandrulesBox = ({ main, q, displayName, editMode }) => {
	const { api } = useApi();
	let acc = 0;

	const normalizeString = (str) => {
		if (!str) return "";
		return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
	};
	function popVote() {
		let path = `handrules/${config.handrulesLobbyId}/pop`;
		api(path, "GET");
	}
	return (
		<div className="mainBox">
			{editMode ? (<div className="pop" onClick={() => { popVote() }}><img src={arrow} className="popIcon" alt="pop" /></div>) : undefined}
			{main ? (<div>
				<HandrulesEntry type={main.type} name={main.name} />
			</div>) : (<div className="handruleEmptyBox">
			</div>)}
			<hr></hr>
			<div className="nextHR">
				{
					q.map((entry, index) => {
						if (normalizeString(entry.name) === normalizeString(displayName)) {

							return <HandrulesEntry key={index} type={entry.type} name={entry.name} no={acc++} />
						} else {
							return <HandrulesEntry key={index} type={entry.type} name={entry.name} />
						}
					})
				}
			</div>
		</div>
	)
}

export default HandrulesBox;